// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a6128366","703":"db349f5d"}[chunkId] + ".chunk.js";
};